import QRPaymentIcon from '../../../../../assets/icons/qr-payment.svg?url';
import DownloadIcon from '../../../../../assets/icons/file-download.svg?url';
import l from '../../../../../lang';
import ButtonCustom from '../../../../common/__deprecated__/button-custom';
import './styles.scss';
import { useEffect, useState } from 'react';
import { useDashboard } from '../../../../../store/dashboard';
import QRCode from 'react-qr-code';

const CreatedQRPay = () => {
  const [url, setUrl] = useState('');
  const { merchantMe } = useDashboard();

  useEffect(() => {
    const checkoutUrl = import.meta.env.REACT_APP_CHECKOUT_DOMAIN_DLGO;

    if (merchantMe) {
      const decryptedToken = `open_link:mid:${merchantMe.id}`;
      const paymentLink = `${checkoutUrl}/open-checkout/${btoa(decryptedToken)}?country=${merchantMe.country}`;
      setUrl(paymentLink);
    }
  }, [merchantMe]);

  const downloadQRCode = () => {
    const svg = document.querySelector('#qr-code');
    if (!svg) return;

    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const size = 1024;
    canvas.width = size;
    canvas.height = size;

    const img = new Image();

    img.onload = () => {
      ctx?.drawImage(img, 0, 0, size, size);

      const link = document.createElement('a');
      link.download = 'qr-code.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    };

    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgData)}`;
  };

  return (
    <div className="created_qr_payment_link">
      <div className="created_qr_payment_link__intro">{l('qrPayment.description')}</div>
      <div className="created_qr_payment_link__box">
        <div className="created_qr_payment_link__icon-wrap">
          <img className="created_qr_payment_link__icon" src={QRPaymentIcon} alt="" />
        </div>
        <h1>{l('qrPayment.title')}</h1>
        <div className="created_qr_payment_link__subheadline">{l('qrPayment.subheadline')}</div>
        <div className="created_qr_payment_link__qr">
          <QRCode id="qr-code" value={url || ' '} size={160} />
        </div>
        <div className="created_qr_payment_link__download">
          <ButtonCustom
            onClick={downloadQRCode}
            variant="outlined"
            text={l('qrPayment.download')}
            startIcon={<img className="created_qr_payment_link__download-icon" src={DownloadIcon} alt="" />}
          />
        </div>
      </div>
    </div>
  );
};

export default CreatedQRPay;
